import { ISubject } from '../../../core/models/subject';
import { DISCIPLINES } from '../../../core/utils/new_discipline';

export const disciplines = DISCIPLINES.filter((it) => !it.disabled).sort((a, b) => a.order - b.order).map((it) => ({
  label: it.name,
  slug: it.slug,
  link: `/disciplinas/${it.slug}`,
}));

export const getActiveItem = (array: any, slug: string, type: string) => {
  if (array && array.length) {
    const activeItem = array.find((it: any) => it.slug === slug);

    const item = { slug: '', title: '' };

    if (!activeItem) {
      return null;
    }

    if (type === 'static') {
      item.slug = activeItem.slug;
      item.title = activeItem.label;
    } else {
      item.slug = activeItem.slug;
      item.title = activeItem.title;
    }

    return item;
  }

  return null;
};

export const verifyActual = (
  contentType: string,
  subjectInfo: ISubject | null
) => {
  if (contentType && subjectInfo) {
    if (contentType === 'videoaula') {
      return subjectInfo?.lessonsCount && subjectInfo?.lessonsCount > 0;
    }
    if (contentType === 'exercicio') {
      return subjectInfo?.exerciseCount && subjectInfo?.exerciseCount > 0;
    }
    if (contentType === 'material') {
      return subjectInfo?.materialCount && subjectInfo.materialCount > 0;
    }
    if (contentType === 'podcast') {
      return subjectInfo?.podcastsCount && subjectInfo.podcastsCount > 0;
    }
  }
};

export const firstWithContent = (
  subjectInfo: ISubject | null,
  contentType: string,
  actualType?: boolean | number
) => {
  if (actualType) {
    return contentType;
  }

  if (subjectInfo?.lessonsCount && subjectInfo?.lessonsCount > 0) {
    return 'videoaula';
  }

  if (subjectInfo?.exerciseCount && subjectInfo?.exerciseCount > 0) {
    return 'exercicio';
  }

  if (subjectInfo?.materialCount && subjectInfo?.materialCount > 0) {
    return 'material';
  }

  if (subjectInfo?.podcastsCount && subjectInfo?.podcastsCount > 0) {
    return 'podcast';
  }

  return contentType;
};
